import { render, staticRenderFns } from "./screw-form.vue?vue&type=template&id=641aba94&"
import script from "./screw-form.vue?vue&type=script&lang=js&"
export * from "./screw-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports